
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Hashtags Instagram : Utilité et Stratégies d’Optimisation",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Maîtrisez l’art des hashtags pour élargir votre audience sur Instagram. Découvrez des astuces pour choisir les meilleurs hashtags et maximiser votre impact en ligne.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Hashtags Instagram : Utilité et Stratégies d’Optimisation",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "L’art d’utiliser les hashtags est essentiel pour toucher un public plus vaste. Que ce soit un simple hashtag ou la quête du meilleur hashtag Instagram, chaque utilisateur aspire à maximiser son impact.",
        },
      ],
    };
  },
};
